<template>
	<div class="content" v-if="showConfim==3">
		<div class="content-assets">
			<div class="flex-cement">
				<div class="cement1">实名认证</div>
				<div class="flex-contact-slices" @click="cloem">
					<img src="@/assets/contact_slices/Vector@2x (8).png" style="width: 14px; height: 14px" />
					<div class="assets-return">返回</div>
				</div>
			</div>
			<div class="border-top"></div>
			<div>
				<div style="display: flex; align-items: center; justify-content: space-between;">
					<div class="flex-csh">
						<div>
							<img src="@/assets/Jingka/basic.png" class="vue-image" />
						</div>
						<div class="flex-assets-list">
							<div class="title">初始认证</div>
							<div class="text">
								完成初级认证后，系统可用额度为2000元，平台大部分产品均可使用
							</div>
						</div>
						<div>
							<div style="display: flex; justify-content: right;">
								<img v-if="userInfo.realType<2" src="@/assets/Jingka/Unverified.png"
									style="width: 70px; height: auto;" />
								<img v-else src="@/assets/Jingka/certified.png" style="width: 70px; height: auto;" />
							</div>
							<div class="authen-tication" @click="goAndConfirm(1)">去认证</div>
						</div>
					</div>

					<div style="border: 1px solid #eeeeee;  height: 80px;"></div>

					<div class="flex-csh">
						<div>
							<img src="@/assets/Jingka/advanced.png" class="vue-image" />
						</div>
						<div class="flex-assets-list">
							<div class="title">高级认证</div>
							<div class="text">
								完成高级认证后，系统可用额度不限额，平台所有产品均可使用，
							</div>
						</div>
						<div>
							<div style="display: flex; justify-content: right;">
								<img v-if="userInfo.realType<3" src="@/assets/Jingka/Unverified.png"
									style="width: 70px; height: auto;" />
								<img v-else src="@/assets/Jingka/certified.png" style="width: 70px; height: auto;" />
							</div>
							<div class="authen-tication" @click="goAndConfirm(2)">去认证</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="content" v-else>
		<div class="content-assets">
			<div class="flex-cement">
				<div class="cement1">实名认证</div>
				<div class="flex-contact-slices" @click="cloem1">
					<img src="@/assets/contact_slices/Vector@2x (8).png" style="width: 14px; height: 14px" />
					<div class="assets-return">返回</div>
				</div>
			</div>
			<div class="border-top"></div>
			<div class="flex-tops">
				<div>
					<div class="user-nickname" style="justify-content: space-between; margin-top: 12px">
						<div class="flex-nickname" style="margin-left: 14px">
							<img src="../../../assets/settings-basic/Group 903@2x.png" style="width: 14px; height: 16px" />
							<div class="name-assets" style="margin-left: 5px">真实姓名</div>
						</div>
						<div class="flex-nickname" style="margin-right: 12px">
							<div>
								<input placeholder="请输入" v-model="realName" class="inputClat" style="width: 170px" />
							</div>
						</div>
					</div>
					<div class="user-nickname" style="justify-content: space-between; margin-top: 12px">
						<div class="flex-nickname" style="margin-left: 14px">
							<img src="../../../assets/settings-basic/Union@2x.png" style="width: 14px; height: 11px" />
							<div class="name-assets" style="margin-left: 5px">身份证号</div>
						</div>
						<div class="flex-nickname" style="margin-right: 12px">
							<div>
								<input placeholder="请输入" v-model="idCard" class="inputClat" style="width: 170px" />
							</div>
						</div>
					</div>
					<div class="user-nickname" style="justify-content: space-between; margin-top: 12px">
						<div class="flex-sarinto" v-if="!image">{{userInfo.realType<2?'未签':'已签'}}</div>
						<div class="flex-sarinto" v-else>
							<img :src="image" style="width: 100%; height: 100%" />
						</div>
						<div class="flex-nickname" style="margin-right: 12px" @click="signatureClick">
							<div style="margin-top: 5px">
								<img src="../../../assets/settings-basic/xgls.png" style="width: 20px; height: 20px" />
							</div>
							<div class="signature" style="margin-left: 6px">签名</div>
						</div>
					</div>
					<div class="submitted" :class="{ submitted1: !idCard || !realName || !image || showTaost}" @click="submitClick">提交认证</div>
				</div>
				<template v-if="showConfim==2">
					<div class="bor-tops" v-if="imageSrc"></div>
					<div style="margin-top: 18px" v-if="imageSrc">
						<qrcode-vue :value="imageSrc" :size="150"></qrcode-vue>
						<div class="flex-image" v-if="1">
							<img src="@/assets/settings-basic/Group 1531@2x.png" style="width: 14px; height: 14px" />
							<div class="name-list">扫码人脸识别</div>
						</div>
						<div class="flex-image" v-else>
							<img src="@/assets/settings-basic/Group 1534@2x.png" style="width: 14px; height: 14px" />
							<div class="name-list" style="color: #28c445">识别成功</div>
						</div>
					</div>
				</template>
			</div>
		</div>
		<div style="height: 198px"></div>
		<PopupCopy @singnClick="signatureClick" @singfklaintoa="singfkClick" v-if="showPopup"></PopupCopy>
	</div>
</template>

<script setup>
	import {
		onMounted,
		ref
	} from 'vue';
	import QrcodeVue from 'qrcode.vue';
	import PopupCopy from './popupCopy.vue';
	import axios from 'axios';
	import {
		userReaLIdcard,
		memberUserRealSign,
		infraFileUpload
	} from '@/utils/api.js';
	import {
		ElMessage
	} from 'element-plus';
	import {
		memberUserGet,
		memberUserRealFace
	} from '@/utils/api.js';
	let emit = defineEmits(['reoutnCart']);
	let ids = ref(1);
	let idCard = ref('');
	let realName = ref('');
	let showPopup = ref(false);
	let image = ref('');
	let userInfo = ref({});
	let imageSrc = ref('');
	let signFile = ref('');
	let showTaost = ref(false)
	const cloem = () => {
		emit('reoutnCart');
	};
	const cloem1 = () => {
		showConfim.value = 3;
	};
	let showConfim = ref(3);
	const goAndConfirm = (index) => {
		if (index == 1) {
			if (userInfo.value.realType >= 2) {
				ElMessage({
					message: '初级认证已完成',
					type: 'error'
				});
				return false;
			}
		}
		showConfim.value = index;
	}
	const signatureClick = () => {
		if (userInfo.value.realType < 2) {
			showPopup.value = !showPopup.value;
		} else {
			ElMessage({
				message: '已完成初级认证',
				type: 'success'
			});
		}
	};

	const base64ToBinary = (base64) => {
		const binaryString = atob(base64.split(',')[1]); // 去掉base64前缀，并解码
		const len = binaryString.length;
		const bytes = new Uint8Array(len);
		for (let i = 0; i < len; i++) {
			bytes[i] = binaryString.charCodeAt(i);
		}
		return bytes.buffer;
	}

	let fileInput = ref('');
	const singfkClick = (item) => {
		image.value = item;
		const formData = new FormData();
		const base64 = base64ToBinary(image.value);
		const blob = new Blob([new Uint8Array(base64)], {
			type: 'image/png'
		});
		formData.append('file', blob);
		console.log(11111,formData)
		axios.post('/infra/file/upload', formData, {
				header: {
					Accept: '*/*',
					'tenant-id': '1',
				},
			})
			.then(response => {
				signFile.value = response.data.data;
			})
		signatureClick();
	};
	const submitClick = async () => {
		if(showTaost.value) return
		if (!idCard.value || !realName.value || !image.value) {
			return false;
		}
		let res = await userReaLIdcard({
			idCard: idCard.value,
			realName: realName.value
		});
		setTimeout(async () => {
			let meds = await memberUserRealSign({
				signFile: signFile.value
			})
			if (res.data) {
				ElMessage({
					message: '初级认证成功',
					type: 'success'
				});
				let ref = await memberUserGet();
				userInfo.value = ref.data;
				info();
				localStorage.setItem('information', JSON.stringify(ref.data));
				showTaost.value = true;
			} else {
				ElMessage({
					message: res.msg,
					type: 'error'
				});
			}
		}, 1500)
	};
	const info = async () => {
		let res = await memberUserRealFace();
		imageSrc.value = res.data;
	};
	const infoatin = async () => {
		let res = await memberUserGet();
		localStorage.setItem('information', JSON.stringify(res.data));
		userInfo.value = res.data ? res.data : {};
		if (userInfo.value) {
			idCard.value = userInfo.value.idCard;
			realName.value = userInfo.value.realName;
		}
	};
	onMounted(() => {
		info();
		userInfo.value = JSON.parse(localStorage.getItem('information'));
		if (userInfo.value) {
			idCard.value = userInfo.value.idCard;
			realName.value = userInfo.value.realName;
		}
	});
</script>

<style lang="scss" scoped>
	.content-assets {
		padding: 20px 21px;
	}

	.content {
		width: 85%;
		background-color: #fff;
		margin-left: 20px;
		margin-left: auto;
	}

	.flex-cement {
		position: relative;
		display: flex;
		align-items: center;

		.cement1 {
			font-family: PingFang SC, PingFang SC;
			font-weight: 600;
			font-size: 20px;
			color: #333333;
			font-style: normal;
			text-transform: none;
		}
	}

	.flex-contact-slices {
		position: absolute;
		top: 0;
		right: 0;
		display: flex;
		align-items: center;
	}

	.assets-return {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #333333;
		font-style: normal;
		text-transform: none;
		margin-left: 4px;
		margin-top: 2px;
	}

	.border-top {
		width: 99%;
		height: 0px;
		border-top: 1px solid #eeeeee;
		margin-top: 16px;
		padding-top: 16px;
	}

	.flex-const-slice {
		display: flex;
		margin-top: 10px;
	}

	.title-slice {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 18px;
		color: #333333;
		text-align: left;
		font-style: normal;
		text-transform: none;
		margin-top: 2px;
	}

	.title-slice1 {
		color: #ff2f17;
	}

	.december {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 17px;
		color: #aaaaaa;
		font-style: normal;
		text-transform: none;
		margin-left: 5px;
		margin-top: -2px;
	}

	.flex-top {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.flex-more {
		display: flex;
		justify-content: space-between;
		margin-left: 44px;
		margin-top: 30px;
	}

	.more-text {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		text-align: center;
		font-style: normal;
		margin-top: 6px;
		text-transform: none;
	}

	.hot-group {
		white-space: nowrap;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 11px;
		color: #000000;
		font-style: normal;
		text-transform: none;
		padding-bottom: 7px;
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-left: -10px;
	}

	.hot-group1 {
		margin-top: 80px;
	}

	.title-tots {
		white-space: nowrap;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 11px;
		color: #000000;
		font-style: normal;
		text-transform: none;
	}

	.hot-slices {
		margin: auto;
		width: 50px;
		height: 0px;
		border-top: 2px solid #eeeeee;
		padding-top: 10px;
	}

	.images {
		width: 85%;
		height: auto;
	}

	.assets-vector {
		width: 94%;
		background: #fff5f5;
		border-radius: 7px;
		margin: auto;
		margin-top: 70px;
	}

	.asset-paingd {
		padding: 16px 12px;
		display: flex;
		align-items: center;
	}

	.title-asset {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #db8a8a;
		font-style: normal;
		text-transform: none;
		margin-left: 8px;
	}

	.positioning {
		position: relative;
		margin-left: 11px;
	}

	.settlement {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #ff2f17;
		font-style: normal;
		text-transform: none;
		position: absolute;
		top: 6px;
		left: 16px;
	}

	.cash-amount {}

	.cash-title {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		font-style: normal;
		text-transform: none;
	}

	.cash-price {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 12px;
		color: #ec3925;
		font-style: normal;
		text-transform: none;
		margin-top: 10px;
	}

	.withdrawal1 {
		width: 139px;
		height: 42px;
		background: #ff2f17;
		border-radius: 4px 4px 4px 4px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #ffffff;
		line-height: 42px;
		text-align: center;
		font-style: normal;
		text-transform: none;
		margin-top: 9px;
	}

	.flex-right-paynces {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.flex-rightTap {
		display: flex;
		align-items: center;
		margin-left: -34px;
	}

	.flex-rightTap1 {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin-left: 54px;
	}

	.all-title1 {
		color: #ec3925;
	}

	.flex-date-filter {
		display: flex;
		align-content: center;
		align-items: center;
		margin-top: -16px;
	}

	.date-filter {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #aaaaaa;
		font-style: normal;
		text-transform: none;
		margin-right: 10px;
	}

	.query-title {
		width: 52px;
		height: 32px;
		background: #ff3333;
		border-radius: 4px 4px 4px 4px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #ffffff;
		line-height: 32px;
		text-align: center;
		font-style: normal;
		text-transform: none;
		margin-left: 11px;
	}

	.border-top4 {
		width: 29px;
		height: 2px;
		background: #ec3925;
		border-radius: 0px 0px 0px 0px;
		margin-top: 13px;
	}

	.border-top3 {
		width: 29px;
		height: 2px;
		border-radius: 0px 0px 0px 0px;
		margin-top: 13px;
	}

	.flex-date-type {
		display: flex;
	}

	.Orders-pending {
		margin-top: 32px;
		margin-left: 12px;
		display: flex;
		align-items: flex-end;
	}

	.order-number {
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 24px;
		color: #333333;
		font-style: normal;
		text-transform: none;
	}

	.order-title {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		font-style: normal;
		text-transform: none;
	}

	.border-taops {
		width: 1px;
		height: 18px;
		border-left: 1px solid #eeeeee;
		padding-right: 43px;
		margin-left: 43px;
	}

	.order-id {
		display: flex;
		margin-top: 9px;
	}

	.order-title {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #000;
		font-style: normal;
		text-transform: none;
	}

	.failed {
		width: 68px;
		height: 23px;
		background: #ff3333;
		border-radius: 4px 4px 4px 4px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 11px;
		color: #ffffff;
		line-height: 23px;
		text-align: center;
		font-style: normal;
		text-transform: none;
		margin-left: 27px;
	}

	.flex-user {
		display: flex;
	}

	.user-id {
		width: 256px;
	}

	.user-name {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #aaaaaa;
		font-style: normal;
		text-transform: none;
	}

	.user-numbeer {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #333333;
		font-style: normal;
		text-transform: none;
	}

	.flex-sarinto {
		width: 114px;
		height: 42px;
		background: #f7f2ee;
		border: 1px solid #f7f2ee;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #b8aca3;
		font-style: normal;
		text-transform: none;
		line-height: 42px;
		text-align: center;
	}

	.signature {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #ff3333;
		font-style: normal;
		text-transform: none;
	}

	.submitted {
		width: 162px;
		height: 52px;
		background: #ff3333;
		border-radius: 4px 4px 4px 4px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #ffffff;
		line-height: 52px;
		text-align: center;
		font-style: normal;
		text-transform: none;
		margin-top: 22px;
		margin-left: 20px;
	}

	.flex-tops {
		display: flex;
	}

	.bor-tops {
		width: 1px;
		height: 154px;
		border-left: 1px solid #eeeeee;
		margin-top: 15px;
		margin-left: 30px;
		padding-left: 30px;
	}

	.flex-image {
		display: flex;
		margin-top: 16px;
		margin-left: 20px;
	}

	.name-list {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #aaaaaa;
		font-style: normal;
		text-transform: none;
		margin-top: -4px;
		margin-left: 5px;
	}

	.inputClat {
		text-align: right;
	}

	.submitted1 {
		background: #aaaaaa;
	}

	.vue-image {
		width: 40px;
		height: 40px;
	}

	.flex-csh {
		display: flex;
		align-items: flex-start;
		width: 40%;

		.flex-assets-list {
			margin-left: 25px;

			.title {
				font-weight: 600;
				font-size: 18px;
			}

			.text {
				font-size: 14px;
				color: #b8b8b8;
			}
		}

		.authen-tication {
			width: 90px;
			line-height: 36px;
			margin-top: 8px;
			background: #ff3333;
			border-radius: 4px 4px 4px 4px;
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: #ffffff;
			text-align: center;
			font-style: normal;
			text-transform: none;
		}

		.authen-tication:hover {
			cursor: pointer;
		}
	}
</style>